import React, { useState } from "react";
import Box from "@mui/material/Box";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Fade from "@mui/material/Fade";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import { getClassName } from "@sscs/utils";
import styles from "./popper.module.scss";
const MODIFIERS = [{ name: "offset", options: { offset: [0, 10] } }];
const RichPopper = ({ open, onClose, trigger, content, arrow = true, placement = "bottom", className, }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClose = (event) => {
        if ((event === null || event === void 0 ? void 0 : event.target) instanceof Node && (anchorEl === null || anchorEl === void 0 ? void 0 : anchorEl.contains(event.target))) {
            return;
        }
        onClose();
    };
    return (React.createElement(React.Fragment, null,
        trigger(setAnchorEl),
        anchorEl && (React.createElement(Popper, { open: open, anchorEl: anchorEl, placement: placement, transition: true, className: getClassName(styles.popper, className), modifiers: MODIFIERS }, ({ TransitionProps }) => (React.createElement(ClickAwayListener, { onClickAway: handleClose },
            React.createElement(Fade, { ...TransitionProps, timeout: 350 },
                React.createElement(Paper, { elevation: 0, className: styles["popover-root"] },
                    arrow ? (React.createElement("span", { "data-popper-arrow": true, className: styles.arrow })) : null,
                    React.createElement(Box, { className: styles.content }, content)))))))));
};
export default RichPopper;
//# sourceMappingURL=Popper.js.map